module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic7.bf1a16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic7.png
// module id = 498
// module chunks = 1